module.exports = __webpack_public_path__ + "static/img/profilePhoto.4ee8d503.png";